import { getSimilarityColor } from './result-compare.stats';

export class SimilarityHeaderComponent {
  private eGui!: HTMLElement;

  init(params: any): void {
    const label: string = params.label ?? params.displayName ?? '';
    const avg: number | null = params.avg ?? null;

    const el = document.createElement('div');
    el.style.display = 'flex';
    el.style.alignItems = 'center';
    el.style.justifyContent = 'space-between';
    el.style.gap = '8px';
    el.style.width = '100%';

    const labelSpan = document.createElement('span');
    labelSpan.textContent = label;
    labelSpan.style.overflow = 'hidden';
    labelSpan.style.textOverflow = 'ellipsis';
    labelSpan.style.whiteSpace = 'nowrap';
    el.appendChild(labelSpan);

    if (avg !== null && avg !== undefined) {
      const color = getSimilarityColor(avg);
      const badge = document.createElement('span');
      badge.textContent = `${(avg * 100).toFixed(0)}%`;
      badge.style.background = color + '22';
      badge.style.color = color;
      badge.style.padding = '2px 6px';
      badge.style.borderRadius = '2px';
      badge.style.fontSize = '0.7rem';
      badge.style.fontWeight = '600';
      badge.style.whiteSpace = 'nowrap';
      badge.style.flexShrink = '0';
      el.appendChild(badge);
    }

    this.eGui = el;
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }
}
